/**
 * Do not edit directly, this file was auto-generated.
 */

export const ZBase = 0; // Normal flow.
export const ZRaised = 10; // Slightly above flow — focused field.
export const ZSticky = 100; // Sticky headers, table sticky columns.
export const ZDropdown = 1000; // Open select / autocomplete / menu lists.
export const ZOverlay = 1050; // Backdrop scrim behind modals.
export const ZModal = 1100; // Dialogs, modal panels.
export const ZPopover = 1200; // Floating popovers, callouts.
export const ZTooltip = 1300; // Tooltips — always on top of popovers.
export const ZToast = 1400; // Snackbars and toasts — top of everything.
